export const eBotSensorDataIncompleteAccessList = {
    'ultra': 'ultra.analog.LHS',
    'ultra.analog': 'ultra.analog.LHS',
    'ultra.digital': 'ultra.digital.LHSMax',
    'line': 'line.analog.LHS',
    'line.analog': 'line.analog.LHS',
    'line.digital': 'line.digital.LHSWhite',
    'craneProximity': 'craneProximity.LHS',
    'colour': 'colour.guess',
    'RFID': 'RFID.tagName',
    'wheelDistance': 'wheelDistance.LHS',
    'power': 'power.voltage'
}